import React from "react";

import { ForgotPassword } from "../../../features";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
